import { render, staticRenderFns } from "./StudentRequestLocation.vue?vue&type=template&id=9524c494&"
import script from "./StudentRequestLocation.vue?vue&type=script&lang=js&"
export * from "./StudentRequestLocation.vue?vue&type=script&lang=js&"
import style0 from "./StudentRequestLocation.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports